const API_BASE = 'api';
const authenticationRoutes = {
    LOGIN: '/authentication-token',
    RESET_PASSWORD_REQUEST: '/reset-password-requests',
    RESET_PASSWORD: '/reset-password-requests/{token}',
    TOKEN_REFRESH: '/token/refresh',
};
const syliusApiRoutes = {
    ADDRESSES: '/addresses',
    APPLY_COUPON: '/orders/{token}/apply-coupon',
    CHANGE_ITEM_QUANTITY_BY_ORDER_TOKEN: '/orders/{token}/change-quantity',
    COMPLETE_ORDER_BY_TOKEN: '/orders/{token}/complete',
    COMPLETION_INFORMATION: '/orders/{token}/completion-information?id={id}',
    COUNTRIES: '/countries',
    CUSTOMERS: '/customers',
    ITEM_BY_ID: '/items/{itemId}',
    ORDER_BY_TOKEN: '/orders/{token}',
    PATCH_ORDER_ADDRESS: '/orders/{token}/address',
    PAYMENT_METHODS_BY_ORDER: '/orders/{token}/payment-methods',
    PAYMENT_METHOD_BY_ID: '/payments/{paymentId}',
    TAXONS: '/taxons',
    TAXON_BY_CODE: '/taxons/{code}',
};
const ENDPOINTS = Object.assign(Object.assign({ API_BASE_URL: `/${API_BASE}` }, syliusApiRoutes), authenticationRoutes);
export { API_BASE, ENDPOINTS, authenticationRoutes, syliusApiRoutes };
//# sourceMappingURL=api.js.map